var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86664 0.333147L7.94164 6.40815C8.01975 6.48562 8.08175 6.57778 8.12405 6.67933C8.16636 6.78088 8.18814 6.8898 8.18814 6.99981C8.18814 7.10982 8.16636 7.21875 8.12405 7.32029C8.08175 7.42184 8.01975 7.51401 7.94164 7.59148L1.80831 13.7248C1.73084 13.8029 1.63867 13.8649 1.53712 13.9072C1.43557 13.9495 1.32665 13.9713 1.21664 13.9713C1.10663 13.9713 0.997712 13.9495 0.896163 13.9072C0.794613 13.8649 0.702446 13.8029 0.624977 13.7248H0.666643C0.511434 13.5687 0.424316 13.3575 0.424316 13.1373C0.424316 12.9172 0.511434 12.7059 0.666643 12.5498L6.17498 6.99981L0.666643 1.50815C0.511434 1.35201 0.424316 1.1408 0.424316 0.920647C0.424316 0.700492 0.511434 0.489282 0.666643 0.333147C0.74438 0.252495 0.837579 0.188343 0.94067 0.144526C1.04376 0.100709 1.15463 0.078125 1.26664 0.078125C1.37866 0.078125 1.48953 0.100709 1.59262 0.144526C1.69571 0.188343 1.78891 0.252495 1.86664 0.333147Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.11d26a4ec3362d0c59997491cbb2b4a0.svg";
export { ForwardRef as ReactComponent };